module.exports = __webpack_public_path__ + "static/media/diogo_sa_dias.62e24b73.jpg";